// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-component-wrapper {
	width: 100%;
	height: 100%;
	position: relative;
	background-position: top center;
	background-size: cover;
}

.background-component-video {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.background-component-content {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
}

.overlay {
	height: 100%;
	width: 100%;
	background: #fff;
	opacity: 0.55;
	position: fixed;
}

.dark .overlay {
	background: rgb(7,36,70);
	background: linear-gradient(180deg, rgba(7,36,70,0.8) 22%, rgba(7,36,70,0.5) 100%);
}

.black-friday .overlay {
	background: rgb(184,0,0);
	background: linear-gradient(0deg, rgba(184,0,0,1) 0, rgba(0,0,0,1) 35%);
}
`, "",{"version":3,"sources":["webpack://./Content/Css/Components/background.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,wBAAwB;CACxB,kFAAkF;AACnF;;AAEA;CACC,wBAAwB;CACxB,uEAAuE;AACxE","sourcesContent":[".background-component-wrapper {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tposition: relative;\r\n\tbackground-position: top center;\r\n\tbackground-size: cover;\r\n}\r\n\r\n.background-component-video {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.background-component-content {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n}\r\n\r\n.overlay {\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\tbackground: #fff;\r\n\topacity: 0.55;\r\n\tposition: fixed;\r\n}\r\n\r\n.dark .overlay {\r\n\tbackground: rgb(7,36,70);\r\n\tbackground: linear-gradient(180deg, rgba(7,36,70,0.8) 22%, rgba(7,36,70,0.5) 100%);\r\n}\r\n\r\n.black-friday .overlay {\r\n\tbackground: rgb(184,0,0);\r\n\tbackground: linear-gradient(0deg, rgba(184,0,0,1) 0, rgba(0,0,0,1) 35%);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
